import comp from "./CurriculumOptions";
export default comp;
